import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Box, Grid } from '@material-ui/core';
import { usePaginatedDeductionListItemsQuery } from '../../../../generated/graphql';
import { Table, TablePaginationWithCount } from '../../../../ui-kit';
import { ITEMS_PER_PAGE } from '../constants';
import { deductionListItemsHeadCells } from './constants';
import DeductionListItemsTableContent from './DeductionListItemsTableContent';

const DeductionListTable = () => {
    const { params: { id: deductionListId } } = useRouteMatch();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(ITEMS_PER_PAGE);
    const { data, loading } = usePaginatedDeductionListItemsQuery({ variables: { deductionListId } });

    const { items: deductionListItems, count } = data ? data.paginatedDeductionListItems : { items: [], count: 0 };
    const tablePagination: TablePaginationWithCount = {
        onChangePage: (_, pageNumber) => setPage(pageNumber),
        currentPage: page,
        onChangeRowsPerPage: e => setRowsPerPage(parseInt(e.target.value, 10)),
        rowsPerPage,
        count,
    };

    return (
        <Box mt={3} display='flex' flexGrow={1}>
            <Grid container justify="center" alignItems="center">
                <Grid item xs={12}>
                    <Table fixedLayout headCells={deductionListItemsHeadCells} isFirstColumnSticky tablePagination={tablePagination}>
                        <DeductionListItemsTableContent deductionListItems={deductionListItems} rowsPerPage={10} isLoading={loading} />
                    </Table>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DeductionListTable;